import React from "react"
import ReactInputVerificationCode from "react-input-verification-code"
import "./ConfirmCode.css"

interface IConfirmCodeProps {
  setConfirmValue: React.Dispatch<React.SetStateAction<string>>,
  length: number
}


export const ConfirmCode: React.FC<IConfirmCodeProps> = ({ setConfirmValue, length }) => {
  const handleChange = (value:string) => {
    setConfirmValue(value)
  }

  return (
    <div className="form__confirm-code">
      <ReactInputVerificationCode
        placeholder=""
        onChange={handleChange}
        length={length}
      />
    </div>
  )
}
